import dynamic from 'next/dynamic'

import { Button } from '@thg-commerce/gravity-elements'
import {
  css,
  mq,
  spacing,
  styled,
  Text,
  theme as BaseTheme,
} from '@thg-commerce/gravity-theme'

export const StoreIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Storefront'),
)

export const DetailsCardContainer = styled.div<{
  selected?: boolean
  compactCard?: boolean
  fullWidthCard?: boolean
  clickable?: boolean
}>`
  display: flex;
  flex-direction: column;
  border: 1px solid
    ${(props) =>
      props.selected
        ? props.theme.colors.palette.greys.darker
        : props.theme.colors.palette.greys.light};
  position: relative;
  padding: ${spacing(3)};
  width: 100%;
  background: ${(props) => props.theme.colors.palette.greys.white};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    max-width: ${(props) =>
      props.fullWidthCard
        ? '100%'
        : props.theme.storeDetailsCard?.maxWidth
        ? props.theme.storeDetailsCard?.maxWidth
        : '424px'};
    min-width: 365px;
  }

  ${(props) =>
    props.compactCard && `background: ${BaseTheme.colors.palette.greys.white}`}
  ${(props) => props.clickable && `:hover {cursor: pointer;}`}
`

export const NameWrapper = styled.div`
  ${Text('medium1', 'alternate')};
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
  justify-content: left;
  & a {
    ${Text('medium1', 'alternate')};
    text-decoration: none;
    cursor: pointer;
  }
  & a:hover {
    text-decoration: underline;
  }
`

export const StyledButton = styled(Button)<{ compactCard?: boolean }>`
  height: 48px;
  width: ${(props) => (props.compactCard ? 'calc(50% - 4px)' : '100%')};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: calc(50% - 4px);
  }
  &&,
  &:hover,
  &:active,
  &:focus,
  &:disabled {
    a {
      padding: 0;
    }
  }
`

export const CardFooterContainer = styled.div`
  margin-top: ${spacing(1)};
  display: flex;
  gap: ${spacing(1)};
  flex-wrap: wrap;
  height: 100%;
  align-items: flex-end;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-wrap: nowrap;
  }
`

export const SelectedIconWrapper = styled.div<{
  searchCompactCard?: boolean
}>`
  ${(props) =>
    props.searchCompactCard
      ? css`
          top: 2px;
          right: 2px;
          width: 24px;
          height: 24px;
          position: absolute;
        `
      : css`
          top: 0px;
          right: 0px;
          width: 20px;
          height: 20px;
          position: absolute;
          transform: translate(50%, -50%);
          path {
            fill: ${(props) => props.theme.colors.palette.greys.darker};
          }
          rect {
            fill: ${(props) => props.theme.colors.palette.greys.white};
          }
        `}
`
export const MapPinWrapper = styled.div<{ selected?: boolean }>`
  ${Text('small', 'alternate')};
  color: ${(props) => props.theme.colors.palette.greys.white};
  position: relative;
  width: 32px;
  height: 32px;

  & span {
    width: 100%;
    height: 100%;
    line-height: 24px;
    position: absolute;
    text-align: center;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  path {
    fill: ${(props) =>
      props.selected
        ? props.theme.colors.palette.greys.darker
        : props.theme.colors.palette.accent.base};
  }
`
